import React from 'react';
import { Route, Routes } from 'react-router';
import {
  Header,
  Footer
} from '../index';
import { gsap } from 'gsap';
import Registration from '../Registration/Registration';

function Home() {
  let tl = gsap.timeline();

  return (
    <div>
      <Header timeline={tl} />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="registration" element={<Registration />} />
    </Routes>
  );
}

export default App;
